import { isAuthenticated } from "./code/axios";
import hookManager from "./code/axios";

const tracker = {
  isAuthenticated: isAuthenticated(),

  onLogin() {
    tracker.isAuthenticated = true;
  },
  onLogout() {
    tracker.isAuthenticated = false;
  },
};

hookManager.on("login", tracker.onLogin);
hookManager.on("logout", tracker.onLogout);

const Plugin = {};
Plugin.install = function(Vue) {
  Vue.prototype.$auth = Vue.observable(tracker);
};

export default Plugin;
